export default function setLeadProfileActionCreator(userDuck, personalization) {
  return profile => async dispatch => {
    try {
      const cachedProfile = personalization.getLeadProfileCache();

      // on page load, set user.leadProfile to pre-populate email form fields
      if (!profile && Object.keys(cachedProfile).length) {
        dispatch({
          type: userDuck.types.SET_LEAD_PROFILE,
          payload: cachedProfile
        });
      }

      // submit email for the first time, set local storage and user.leadProfile
      if (profile && !Object.keys(cachedProfile).length) {
        personalization.setLeadProfileCache(profile);
        dispatch({
          type: userDuck.types.SET_LEAD_PROFILE,
          payload: profile
        });
      }

      // submit email, when email form fields are different with cached profile, re-set local storage and user.leadProfile
      if (profile && Object.keys(cachedProfile).length) {
        let isDifferent = false;
        ['firstName', 'lastName', 'email', 'phone', 'isOneClickOptedIn'].forEach(key => {
          if (profile[key] !== cachedProfile[key]) {
            isDifferent = true;
          }
        });
        if (isDifferent) {
          personalization.setLeadProfileCache(profile);
          dispatch({
            type: userDuck.types.SET_LEAD_PROFILE,
            payload: profile
          });
        }
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
  };
}